import { PALETTE } from '../StageData';
import { ShadingPipeline } from '../../engine/ShadingPipeline';
import type { ShapeDrawFn } from './furnitureShapes';

export const gourmetDrawFns: Record<number, ShapeDrawFn> = {
  // STAGE 31: トロピカル・ソフトクリーム
  31: (ctx, cx, cy, mode) => {
    const drawCone = () => {
      ctx.beginPath();
      ctx.moveTo(cx - 55, cy + 20); ctx.lineTo(cx + 55, cy + 20); ctx.lineTo(cx, cy + 160); ctx.closePath();
    };
    const drawSwirl = () => {
      ctx.beginPath();
      ctx.arc(cx, cy - 20, 75, 0, Math.PI * 2);
      ctx.arc(cx, cy - 80, 55, 0, Math.PI * 2);
      ctx.arc(cx, cy - 130, 30, 0, Math.PI * 2);
    };

    if (mode === 'base') {
      ctx.fillStyle = '#FAF8F5'; drawCone(); ctx.fill();
      ctx.fillStyle = '#FAF8F5'; drawSwirl(); ctx.fill();
    } else if (mode === 'outline') {
      ShadingPipeline.renderCarvedOutline(ctx, () => {
        drawCone(); ctx.stroke();
        drawSwirl(); ctx.stroke();
      });
    } else if (mode === 'targetPreview') {
      ctx.fillStyle = ShadingPipeline.createArtisanGradient(ctx, cx, cy + 90, 110, 140, PALETTE.orange, 'cloth');
      drawCone(); ctx.fill();
      const grad = ctx.createLinearGradient(cx, cy - 150, cx, cy + 20);
      grad.addColorStop(0, PALETTE.pink);
      grad.addColorStop(0.5, PALETTE.yellow);
      grad.addColorStop(1, PALETTE.pink);
      ctx.fillStyle = grad; drawSwirl(); ctx.fill();
      ShadingPipeline.renderSpecularGlint(ctx, cx - 25, cy - 80, 20, 40, 0.45);
    }
  },

  // STAGE 32: 苺のショートケーキ
  32: (ctx, cx, cy, mode) => {
    const drawCakeSlice = () => {
      ctx.beginPath();
      ctx.moveTo(cx - 110, cy + 80);
      ctx.lineTo(cx + 110, cy + 80);
      ctx.lineTo(cx + 110, cy - 30);
      ctx.lineTo(cx - 110, cy - 70);
      ctx.closePath();
    };

    if (mode === 'base') {
      ctx.fillStyle = '#FAF8F5'; drawCakeSlice(); ctx.fill();
      ctx.beginPath(); ctx.arc(cx - 20, cy - 95, 26, 0, Math.PI * 2); ctx.fill();
    } else if (mode === 'outline') {
      ShadingPipeline.renderCarvedOutline(ctx, () => {
        drawCakeSlice(); ctx.stroke();
        ctx.beginPath(); ctx.arc(cx - 20, cy - 95, 26, 0, Math.PI * 2); ctx.stroke();
        ctx.beginPath();
        ctx.moveTo(cx - 110, cy + 10); ctx.lineTo(cx + 110, cy + 10);
        ctx.moveTo(cx - 110, cy + 45); ctx.lineTo(cx + 110, cy + 45);
        ctx.stroke();
      });
    } else if (mode === 'targetPreview') {
      ctx.fillStyle = PALETTE.white; drawCakeSlice(); ctx.fill();
      ctx.fillStyle = ShadingPipeline.createArtisanGradient(ctx, cx, cy + 27, 220, 35, PALETTE.gold, 'cloth');
      ctx.fillRect(cx - 110, cy + 10, 220, 35);
      ctx.fillStyle = PALETTE.crimson;
      ctx.beginPath(); ctx.arc(cx - 20, cy - 95, 26, 0, Math.PI * 2); ctx.fill();
      ShadingPipeline.renderSpecularGlint(ctx, cx - 28, cy - 105, 12, 12, 0.6);
    }
  },

  // STAGE 33: カラフル・ドーナツ
  33: (ctx, cx, cy, mode) => {
    const drawDonut = () => {
      ctx.beginPath();
      ctx.arc(cx, cy, 105, 0, Math.PI * 2);
      ctx.arc(cx, cy, 40, 0, Math.PI * 2, true);
      ctx.closePath();
    };

    if (mode === 'base') {
      ctx.fillStyle = '#FAF8F5'; drawDonut(); ctx.fill();
    } else if (mode === 'outline') {
      ShadingPipeline.renderCarvedOutline(ctx, () => {
        drawDonut(); ctx.stroke();
        ctx.beginPath(); ctx.arc(cx, cy, 88, 0, Math.PI * 2); ctx.stroke();
      });
    } else if (mode === 'targetPreview') {
      ctx.fillStyle = ShadingPipeline.createArtisanGradient(ctx, cx, cy, 210, 210, PALETTE.wood, 'wood');
      drawDonut(); ctx.fill();
      ctx.fillStyle = ShadingPipeline.createArtisanGradient(ctx, cx, cy, 180, 180, PALETTE.pink, 'lacquer');
      ctx.beginPath(); ctx.arc(cx, cy, 88, 0, Math.PI * 2); ctx.arc(cx, cy, 42, 0, Math.PI * 2, true); ctx.fill();
      ctx.fillStyle = PALETTE.cyan;
      for (let i = 0; i < 8; i++) {
        const a = (i * Math.PI) / 4;
        ctx.fillRect(cx + Math.cos(a) * 65 - 4, cy + Math.sin(a) * 65 - 4, 8, 8);
      }
      ShadingPipeline.renderSpecularGlint(ctx, cx - 45, cy - 45, 30, 20, 0.55);
    }
  },

  // STAGE 34: 贅沢フルーツパフェ
  34: (ctx, cx, cy, mode) => {
    const drawGlass = () => {
      ctx.beginPath();
      ctx.moveTo(cx - 65, cy - 40); ctx.lineTo(cx + 65, cy - 40); ctx.lineTo(cx + 35, cy + 90); ctx.lineTo(cx - 35, cy + 90); ctx.closePath();
    };

    if (mode === 'base') {
      ctx.fillStyle = '#FAF8F5'; drawGlass(); ctx.fill();
      ctx.fillRect(cx - 8, cy + 90, 16, 50);
      ctx.beginPath(); ctx.ellipse(cx, cy + 140, 55, 16, 0, 0, Math.PI * 2); ctx.fill();
      ctx.beginPath(); ctx.arc(cx, cy - 70, 50, 0, Math.PI * 2); ctx.fill();
    } else if (mode === 'outline') {
      ShadingPipeline.renderCarvedOutline(ctx, () => {
        drawGlass(); ctx.stroke();
        ctx.strokeRect(cx - 8, cy + 90, 16, 50);
        ctx.beginPath(); ctx.ellipse(cx, cy + 140, 55, 16, 0, 0, Math.PI * 2); ctx.stroke();
        ctx.beginPath(); ctx.arc(cx, cy - 70, 50, 0, Math.PI * 2); ctx.stroke();
      });
    } else if (mode === 'targetPreview') {
      ctx.fillStyle = ShadingPipeline.createArtisanGradient(ctx, cx, cy - 70, 100, 100, PALETTE.coral, 'cloth');
      ctx.beginPath(); ctx.arc(cx, cy - 70, 50, 0, Math.PI * 2); ctx.fill();
      ctx.fillStyle = ShadingPipeline.createArtisanGradient(ctx, cx, cy + 25, 130, 130, PALETTE.cyan, 'glass');
      drawGlass(); ctx.fill();
      ctx.fillStyle = PALETTE.white; ctx.fillRect(cx - 50, cy - 20, 100, 25);
      ShadingPipeline.renderSpecularGlint(ctx, cx - 25, cy + 10, 16, 40, 0.6);
    }
  },

  // STAGE 35: クラシック・バーガー
  35: (ctx, cx, cy, mode) => {
    const drawTopBun = () => {
      ctx.beginPath();
      ctx.arc(cx, cy - 40, 95, Math.PI, 0); ctx.closePath();
    };
    const drawBottomBun = () => {
      ctx.beginPath();
      ctx.roundRect(cx - 95, cy + 40, 190, 35, 12);
    };

    if (mode === 'base') {
      ctx.fillStyle = '#FAF8F5'; drawTopBun(); ctx.fill(); drawBottomBun(); ctx.fill();
      ctx.fillRect(cx - 105, cy - 15, 210, 35);
    } else if (mode === 'outline') {
      ShadingPipeline.renderCarvedOutline(ctx, () => {
        drawTopBun(); ctx.stroke();
        drawBottomBun(); ctx.stroke();
        ctx.strokeRect(cx - 105, cy - 15, 210, 35);
      });
    } else if (mode === 'targetPreview') {
      ctx.fillStyle = ShadingPipeline.createArtisanGradient(ctx, cx, cy - 40, 190, 95, PALETTE.orange, 'cloth');
      drawTopBun(); ctx.fill();
      drawBottomBun(); ctx.fill();
      ctx.fillStyle = ShadingPipeline.createArtisanGradient(ctx, cx, cy + 2, 210, 35, PALETTE.darkWood, 'wood');
      ctx.fillRect(cx - 105, cy - 15, 210, 35);
      ctx.fillStyle = PALETTE.yellow;
      ctx.beginPath(); ctx.moveTo(cx - 85, cy); ctx.lineTo(cx + 85, cy); ctx.lineTo(cx, cy + 28); ctx.closePath(); ctx.fill();
      ShadingPipeline.renderSpecularGlint(ctx, cx - 35, cy - 65, 45, 16, 0.45);
    }
  },

  // STAGE 36: 熱々イタリアンピザ
  36: (ctx, cx, cy, mode) => {
    const drawPizzaSlice = () => {
      ctx.beginPath();
      ctx.moveTo(cx, cy + 140);
      ctx.lineTo(cx - 105, cy - 110);
      ctx.arc(cx, cy - 110, 105, Math.PI, 0);
      ctx.lineTo(cx, cy + 140);
      ctx.closePath();
    };

    if (mode === 'base') {
      ctx.fillStyle = '#FAF8F5'; drawPizzaSlice(); ctx.fill();
    } else if (mode === 'outline') {
      ShadingPipeline.renderCarvedOutline(ctx, () => {
        drawPizzaSlice(); ctx.stroke();
        for (let i = -1; i <= 1; i++) {
          ctx.beginPath(); ctx.arc(cx + i * 40, cy - 30 + Math.abs(i) * 30, 18, 0, Math.PI * 2); ctx.stroke();
        }
      });
    } else if (mode === 'targetPreview') {
      ctx.fillStyle = ShadingPipeline.createArtisanGradient(ctx, cx, cy, 210, 250, PALETTE.yellow, 'lacquer');
      drawPizzaSlice(); ctx.fill();
      ctx.fillStyle = PALETTE.crimson;
      for (let i = -1; i <= 1; i++) {
        ctx.beginPath(); ctx.arc(cx + i * 40, cy - 30 + Math.abs(i) * 30, 18, 0, Math.PI * 2); ctx.fill();
      }
      ctx.fillStyle = PALETTE.emerald;
      ctx.beginPath(); ctx.arc(cx - 15, cy + 35, 10, 0, Math.PI * 2); ctx.fill();
      ShadingPipeline.renderSpecularGlint(ctx, cx - 25, cy - 60, 35, 20, 0.45);
    }
  },

  // STAGE 37: レインボー・ロリポップ
  37: (ctx, cx, cy, mode) => {
    const drawCandy = () => {
      ctx.beginPath();
      ctx.arc(cx, cy - 35, 95, 0, Math.PI * 2);
    };

    if (mode === 'base') {
      ctx.fillStyle = '#FAF8F5'; drawCandy(); ctx.fill();
      ctx.fillRect(cx - 8, cy + 60, 16, 150);
    } else if (mode === 'outline') {
      ShadingPipeline.renderCarvedOutline(ctx, () => {
        drawCandy(); ctx.stroke();
        ctx.strokeRect(cx - 8, cy + 60, 16, 150);
        ctx.beginPath(); ctx.arc(cx, cy - 35, 65, 0, Math.PI * 2); ctx.stroke();
        ctx.beginPath(); ctx.arc(cx, cy - 35, 35, 0, Math.PI * 2); ctx.stroke();
      });
    } else if (mode === 'targetPreview') {
      ctx.fillStyle = PALETTE.white; ctx.fillRect(cx - 8, cy + 60, 16, 150);
      ctx.fillStyle = ShadingPipeline.createArtisanGradient(ctx, cx, cy - 35, 190, 190, PALETTE.pink, 'lacquer');
      drawCandy(); ctx.fill();
      ctx.fillStyle = ShadingPipeline.createArtisanGradient(ctx, cx, cy - 35, 130, 130, PALETTE.cyan, 'lacquer');
      ctx.beginPath(); ctx.arc(cx, cy - 35, 65, 0, Math.PI * 2); ctx.fill();
      ctx.fillStyle = ShadingPipeline.createArtisanGradient(ctx, cx, cy - 35, 70, 70, PALETTE.yellow, 'lacquer');
      ctx.beginPath(); ctx.arc(cx, cy - 35, 35, 0, Math.PI * 2); ctx.fill();
      ShadingPipeline.renderSpecularGlint(ctx, cx - 35, cy - 70, 30, 30, 0.6);
    }
  },

  // STAGE 38: パステル・マカロン
  38: (ctx, cx, cy, mode) => {
    const drawMacaronTier = (y: number) => {
      ctx.beginPath();
      ctx.roundRect(cx - 85, y, 170, 42, 20);
    };

    if (mode === 'base') {
      ctx.fillStyle = '#FAF8F5';
      drawMacaronTier(cy - 110); ctx.fill();
      drawMacaronTier(cy - 40); ctx.fill();
      drawMacaronTier(cy + 30); ctx.fill();
    } else if (mode === 'outline') {
      ShadingPipeline.renderCarvedOutline(ctx, () => {
        drawMacaronTier(cy - 110); ctx.stroke();
        drawMacaronTier(cy - 40); ctx.stroke();
        drawMacaronTier(cy + 30); ctx.stroke();
      });
    } else if (mode === 'targetPreview') {
      ctx.fillStyle = ShadingPipeline.createArtisanGradient(ctx, cx, cy - 89, 170, 42, PALETTE.lavender, 'cloth');
      drawMacaronTier(cy - 110); ctx.fill();
      ctx.fillStyle = ShadingPipeline.createArtisanGradient(ctx, cx, cy - 19, 170, 42, PALETTE.pink, 'cloth');
      drawMacaronTier(cy - 40); ctx.fill();
      ctx.fillStyle = ShadingPipeline.createArtisanGradient(ctx, cx, cy + 51, 170, 42, PALETTE.cyan, 'cloth');
      drawMacaronTier(cy + 30); ctx.fill();
      ShadingPipeline.renderSpecularGlint(ctx, cx - 35, cy - 95, 35, 10, 0.4);
      ShadingPipeline.renderSpecularGlint(ctx, cx - 35, cy - 25, 35, 10, 0.4);
      ShadingPipeline.renderSpecularGlint(ctx, cx - 35, cy + 45, 35, 10, 0.4);
    }
  },

  // STAGE 39: 原宿チョコバナナクレープ
  39: (ctx, cx, cy, mode) => {
    const drawCrepe = () => {
      ctx.beginPath();
      ctx.moveTo(cx, cy + 170); ctx.lineTo(cx - 85, cy - 80); ctx.arc(cx, cy - 80, 85, Math.PI, 0); ctx.lineTo(cx, cy + 170); ctx.closePath();
    };

    if (mode === 'base') {
      ctx.fillStyle = '#FAF8F5'; drawCrepe(); ctx.fill();
    } else if (mode === 'outline') {
      ShadingPipeline.renderCarvedOutline(ctx, () => {
        drawCrepe(); ctx.stroke();
        ctx.beginPath(); ctx.arc(cx - 25, cy - 90, 22, 0, Math.PI * 2); ctx.stroke();
        ctx.beginPath(); ctx.arc(cx + 25, cy - 90, 22, 0, Math.PI * 2); ctx.stroke();
      });
    } else if (mode === 'targetPreview') {
      ctx.fillStyle = ShadingPipeline.createArtisanGradient(ctx, cx, cy + 45, 170, 250, PALETTE.gold, 'cloth');
      drawCrepe(); ctx.fill();
      ctx.fillStyle = PALETTE.white;
      ctx.beginPath(); ctx.arc(cx - 25, cy - 90, 22, 0, Math.PI * 2); ctx.fill();
      ctx.beginPath(); ctx.arc(cx + 25, cy - 90, 22, 0, Math.PI * 2); ctx.fill();
      ctx.fillStyle = PALETTE.darkWood;
      ctx.fillRect(cx - 45, cy - 40, 90, 12);
    }
  },

  // STAGE 40: 職人の木製寿司盛り合わせ
  40: (ctx, cx, cy, mode) => {
    const drawGeta = () => {
      ctx.beginPath();
      ctx.roundRect(cx - 125, cy - 45, 250, 95, 8);
    };

    if (mode === 'base') {
      ctx.fillStyle = '#FAF8F5'; drawGeta(); ctx.fill();
      ctx.fillRect(cx - 95, cy + 50, 25, 45);
      ctx.fillRect(cx + 70, cy + 50, 25, 45);
      ctx.beginPath(); ctx.ellipse(cx - 65, cy - 15, 40, 20, 0, 0, Math.PI * 2); ctx.fill();
      ctx.beginPath(); ctx.ellipse(cx + 65, cy - 15, 40, 20, 0, 0, Math.PI * 2); ctx.fill();
    } else if (mode === 'outline') {
      ShadingPipeline.renderCarvedOutline(ctx, () => {
        drawGeta(); ctx.stroke();
        ctx.strokeRect(cx - 95, cy + 50, 25, 45);
        ctx.strokeRect(cx + 70, cy + 50, 25, 45);
        ctx.beginPath(); ctx.ellipse(cx - 65, cy - 15, 40, 20, 0, 0, Math.PI * 2); ctx.stroke();
        ctx.beginPath(); ctx.ellipse(cx + 65, cy - 15, 40, 20, 0, 0, Math.PI * 2); ctx.stroke();
      });
    } else if (mode === 'targetPreview') {
      ctx.fillStyle = ShadingPipeline.createArtisanGradient(ctx, cx, cy + 20, 250, 140, PALETTE.wood, 'wood');
      drawGeta(); ctx.fill();
      ctx.fillRect(cx - 95, cy + 50, 25, 45);
      ctx.fillRect(cx + 70, cy + 50, 25, 45);
      ctx.fillStyle = ShadingPipeline.createArtisanGradient(ctx, cx - 65, cy - 15, 80, 40, PALETTE.crimson, 'lacquer');
      ctx.beginPath(); ctx.ellipse(cx - 65, cy - 15, 40, 20, 0, 0, Math.PI * 2); ctx.fill();
      ctx.fillStyle = ShadingPipeline.createArtisanGradient(ctx, cx + 65, cy - 15, 80, 40, PALETTE.coral, 'lacquer');
      ctx.beginPath(); ctx.ellipse(cx + 65, cy - 15, 40, 20, 0, 0, Math.PI * 2); ctx.fill();
      ShadingPipeline.renderSpecularGlint(ctx, cx - 75, cy - 20, 20, 8, 0.6);
      ShadingPipeline.renderSpecularGlint(ctx, cx + 55, cy - 20, 20, 8, 0.6);
    }
  }
};
